export const NEW_GROUP_ID = 'NewClientWizardNewGroup';
export const NEW_BRAND_ID = 'NewClientWizardNewBrand';

export const newSiteId = (n: number): string => `NewClientWizardNewSite-${n}`;
